import { Updater } from "@tanstack/react-table";
import { PlaylistUploadDto, PostDownloadDto } from "collaboration-service";
import { UploadList } from "components/PostEdit/GeneralPostEditStateHandling";
import * as _ from "lodash";
import * as React from 'react';
import { createDispatchHook, createSelectorHook, createStoreHook, Provider, ReactReduxContextValue } from 'react-redux';
import { createSubscription } from "react-redux/es/utils/Subscription";
import { AnyAction, createStore, Dispatch, Store } from 'redux';
import { ignoreUndefinedCustomizer, reducerSetIfChanged, reducerUpdater } from "services/Helpers";
import PlaylistUpdater from "./PlaylistUpdater";

export type PlaylistEditAction =
    | { type: "batch", actions: PlaylistEditAction[] }
    | { type: "init", playlist?: PlaylistUploadDto }
    | { type: "setPlaylist", playlist?: PlaylistUploadDto }
    | { type: "setOriginalPlaylist", playlist?: PlaylistUploadDto }
    | { type: "setValue", nameStack: string[], value: any, force?: boolean }
    | { type: "resetValue", nameStack: string[], lng?: string }
    | { type: "addFile", nameStack: string[], lng?: string, selectMediaForLng?: string[] }
    | { type: "removeFile", nameStack: string[], lng?: string, selectMediaForLng?: string[] }
    | { type: "setExpertMode", expertMode: Updater<boolean> }
    | { type: "setPosts", posts: Updater<PostDownloadDto[] | undefined> }
    | { type: "setMissing", missing: PLEMissing }
    ;
type A = PlaylistEditAction;

export const PlaylistEditActions = {
    batch: (actions: PlaylistEditAction[]): A => ({ type: "batch", actions }),
    init: (playlist?: PlaylistUploadDto): A => ({ type: "init", playlist }),
    setPlaylist: (playlist?: PlaylistUploadDto): A => ({ type: "setPlaylist", playlist }),
    setOriginalPlaylist: (playlist?: PlaylistUploadDto): A => ({ type: "setOriginalPlaylist", playlist }),
    setValue: (nameStack: string[], value: any, force?: boolean): A => ({ type: "setValue", nameStack, value, force }),
    resetValue: (nameStack: string[]): A => ({ type: "resetValue", nameStack }),
    addFile: (nameStack: string[], lng?: string, selectMediaForLng?: string[]): A => ({ type: "addFile", nameStack, lng, selectMediaForLng }),
    removeFile: (nameStack: string[], lng?: string, selectMediaForLng?: string[]): A => ({ type: "removeFile", nameStack, lng, selectMediaForLng }),
    setExpertMode: (expertMode: Updater<boolean>): A => ({ type: "setExpertMode", expertMode }),
    setPosts: (posts?: Updater<PostDownloadDto[] | undefined>): A => ({ type: "setPosts", posts }),
    setMissing: (missing: PLEMissing): A => ({ type: "setMissing", missing }),

};

export type PLEGeneralSettingsMissing = {
    headline?: boolean;
    media?: boolean;
    groupId?: boolean;
    description?: boolean;
}
export type PLEContentMissing = {
    contents?: boolean;
}

export type PLENodeMissing = {
    headlines?: boolean;
    color?: boolean;
    missingDuration?: boolean;
    missingDueDateRelativeTo?: boolean;
    missingAbsoluteDueDate?: boolean;
    missingRelativeDueDate?: boolean;
    numberTooHigh?: boolean;
    missingNode?: boolean;
    referenceIds?: boolean;
    absCountDone?: boolean;
    successorReferenceValue?: boolean;
}

export type PLEPhasesMissing = {
    startNode?: boolean;
    nodeMissing?: boolean;
    nodes: { [nodeId: string]: PLENodeMissing };
}
export type PLEAutomationMissing = {
}

export type PLEAccessMissing = {
}
export type PLEMissing = {
    generalSettings: PLEGeneralSettingsMissing;
    content: PLEContentMissing;
    phases: PLEPhasesMissing;
    automation: PLEAutomationMissing;
    access: PLEAccessMissing;
}

export interface PlaylistEditState {
    playlist?: PlaylistUploadDto & { id?: string };
    originalPlaylist?: PlaylistUploadDto & { id?: string };
    expertMode: boolean;
    files: UploadList[];
    posts: PostDownloadDto[] | undefined;
    missing: PLEMissing;
}

const initPlaylistEditState = (): PlaylistEditState => {
    return {
        expertMode: false,
        files: [],
        posts: undefined,
        missing: {
            automation: {},
            content: {},
            generalSettings: {},
            phases: {
                nodes: {},
            },
            access: {},
        },
    };
}

export var getValPLE = (data: any, nameStack: string[]) => {
    let cur: any = data;
    for (let i = 0; i < nameStack.length; i++)
        cur = cur[nameStack[i]];
    return cur;
}
export var setValPLE = <T extends any>(data: T, nameStack: string[], value: any, force?: boolean): { changed: boolean, data: T } => {
    // console.log('data => ', data);
    // console.log('nameStack => ', nameStack);
    // console.log('value => ', value);
    const p = _.clone(data);
    let cur: any = p;
    for (let i = 0; i < nameStack.length - 1; i++)
        cur = cur[nameStack[i]];
    const il = nameStack[nameStack.length - 1];
    // console.log('il => ', il);
    let val: any = value;
    if (typeof value === "function") {
        if (il)
            val = value(cur[il]);
        else
            val = value(cur);
    }
    // console.log('val => ', val);
    // console.log('cur => ', cur);
    // console.log('!_.isEqual(il ? cur[il] : cur, val) => ', !_.isEqual(il ? cur[il] : cur, val));
    if (!_.isEqualWith(il ? cur[il] : cur, val, ignoreUndefinedCustomizer)) {
        if (il) {
            cur[il] = val;
            return { changed: true, data: p };
        }
        else
            return { changed: true, data: val };

    }
    return { changed: force ?? false, data }
}

export const playlistEditReducer = (state: PlaylistEditState = initPlaylistEditState(), action: PlaylistEditAction): PlaylistEditState => {
    //console.log('action => ', action);
    switch (action.type) {
        case "batch":
            {
                let s = state;
                _.forEach(action.actions, a => {
                    s = playlistEditReducer(s, a)
                });
                return s;
            }
        case "init":
            {
                let s = reducerSetIfChanged(state, "playlist", action.playlist, undefined, ignoreUndefinedCustomizer);
                s = reducerSetIfChanged(s, "originalPlaylist", action.playlist, undefined, ignoreUndefinedCustomizer);
                return s;
            }
        case "setPlaylist":
            return reducerSetIfChanged(state, "playlist", action.playlist, undefined, ignoreUndefinedCustomizer);
        case "setValue": {
            const c = setValPLE(state.playlist, action.nameStack, action.value, action.force);
            //            console.log('c => ', c);
            if (c.changed)
                return { ...state, playlist: c.data };
            return state;
        }
        case "addFile":
            if (_.find(state.files, nm => _.isEqual(nm.nameStack, action.nameStack) && nm.lng === action.lng && _.isEqual(nm.selectMediaForLng, action.selectMediaForLng)) === undefined) {
                return { ...state, files: [...state.files, { nameStack: action.nameStack, lng: action.lng, selectMediaForLng: action.selectMediaForLng }] };
            }
            return state;
        case "removeFile": {
            const files = _.clone(state.files);
            const idx = _.findIndex(files, nm => _.isEqual(nm, action.nameStack) && nm.lng === action.lng && _.isEqual(nm.selectMediaForLng, action.selectMediaForLng));
            if (idx >= 0) {
                files.splice(idx, 1);
                return { ...state, files };
            }
            return state;
        }
        case "setOriginalPlaylist":
            return reducerSetIfChanged(state, "originalPlaylist", action.playlist, undefined, ignoreUndefinedCustomizer);
        case "resetValue": {
            const oV = getValPLE(state.originalPlaylist, action.nameStack);
            const c = setValPLE(state.playlist, action.nameStack, oV);
            if (c.changed)
                return { ...state, playlist: c.data };
            return state;
        }
        case "setExpertMode":
            return reducerUpdater(state, "expertMode", action.expertMode);
        case "setPosts":
            return reducerUpdater(state, "posts", action.posts);
        case "setMissing":
            return reducerSetIfChanged(state, "missing", action.missing, undefined, ignoreUndefinedCustomizer);
    }
};



interface PlaylistEditProps {
    playlist?: PlaylistUploadDto;
    groupId?: string;
}
export type PlaylistEditorProps = Omit<PlaylistEditProps, "post" | "groupId">;
export const playlistEditStore = createStore(playlistEditReducer);
export const playlistEditContext = React.createContext<ReactReduxContextValue<any, AnyAction>>({
    store: playlistEditStore,
    subscription: createSubscription(playlistEditStore)
});

type UseSelectorPLEType = <TSelected = unknown>(selector: (state: PlaylistEditState) => TSelected, equalityFn?: ((left: TSelected, right: TSelected) => boolean) | undefined) => TSelected
type UseDispatchPLEType = () => Dispatch<PlaylistEditAction>;
type UseStorePLEType = () => Store<PlaylistEditState, PlaylistEditAction>
export const useStorePLE = createStoreHook(playlistEditContext) as UseStorePLEType;
export const useDispatchPLE = createDispatchHook(playlistEditContext) as UseDispatchPLEType;
export const useSelectorPLE = createSelectorHook(playlistEditContext) as UseSelectorPLEType;

const PlaylistEdit = (p: PlaylistEditProps & { children?: JSX.Element | JSX.Element[] }) => {
    const { playlist, groupId, children } = p;
    return (
        <Provider context={playlistEditContext} store={playlistEditStore} >
            <PlaylistUpdater playlist={playlist} groupId={groupId} >
                {children}
            </PlaylistUpdater>
        </Provider >
    );
}
export default PlaylistEdit;
